import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "a85c55d0-4ca6-46ab-a45a-2ab8e23082d5",
    content: "Distance perception of a sound source is often easier in rooms.",
    options: {},
  },
  {
    id: "87133717-da28-4d6e-9481-e76c94f4cd35",
    content: "Sound sources in the median plane can be easily localized by a listener.",
    options: {},
  },
  {
    id: "5d848e54-33df-4acf-96c8-ab0367d4e20e",
    content: "The pattern of the early reflections are the acoustic 'fingerprint'<br>of how a source sounds in a room.",
    options: {},
  },
];

export const task: Task = {
  id: "eb068af4-2899-40cc-837b-dd34a3269d4d",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["a85c55d0-4ca6-46ab-a45a-2ab8e23082d5", "5d848e54-33df-4acf-96c8-ab0367d4e20e"],
};
